import React from 'react';
import { Switch } from 'react-router-dom';
import ProtectedRoute from '../../utils/ProtectedRoute';
import ReconciliationPage from './ReconciliationPage';
import { usePermissions } from '../../providers/Permissions.provider';

const Routes = (): React.JSX.Element => {
  const { permissions } = usePermissions();
  return (
    <Switch>
      <ProtectedRoute
        isAllowed={!!permissions.PartnerHasVirtualAccounts}
        showPermission
        exact
        path="/reconciliation"
        component={ReconciliationPage}
      />
    </Switch>
  );
};

export default Routes;
